import React, {ChangeEvent, FormEvent, SyntheticEvent} from "react";
import styles from "../index.module.css";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, {DateClickArg} from '@fullcalendar/interaction';
import ruLocale from '@fullcalendar/core/locales/ru';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import {
    Button,
    ButtonGroup,
    Segment,
    Icon,
    Radio,
    Checkbox,
    CheckboxProps,
    Dropdown,
    DropdownItemProps,
    DropdownProps,
    Form,
    InputOnChangeData,
    Loader,
    Modal,
    TextAreaProps,
} from "semantic-ui-react";
import ReactInputMask from "react-input-mask";
import {
    EventRepeater, getEventTypesOptions,
    getPatientDailyEventEndDate,
    getPatientMonthlyEventEndDate,
    getPatientWeeklyEventEndDate, getRepeatTypesOptions,
    handleDatePickerKeyDown,
    convertDateToCalendarDate
} from "../../../helpers/CalendarEventsRepeater";
import agent, {PaginateOptions} from "../../../agent";
import {
    AppMode,
    DoctorTitleCase,
    GeneralTitleCase,
    getDoctorTitle,
    getGeneralTitle,
    getTZ,
    safeParseInt
} from "../../../utils/common";
import { uploadPendingFiles } from "../../../helpers/fileUploadUtils";
import {Appointment, Patient} from "../../dashboard";
import {Utils} from "../../../helpers/Utils";
import MediaQuery from "react-responsive";
import {EventClickArg} from "@fullcalendar/core";
import moment from "moment";
import {AppointmentPaginationResponse} from "../../workTableAppointments/AppointmentList";
import {hasRole, UserRole} from "../../../helpers/UserRole";
import {FinishTypes, EventTypes, RepeatTypes, DaysOfWeek } from "../../../enums/EventEnums"
import {
    daysCheckboxes,
    buildCancellationTimeframeFrom,
    buildCancellationTimeframeTo, EMPTY_SLATE_VALUE
} from "../../../consts/EventConsts"
import { textLabels } from "../../../consts/textLabels";
import { EVENT_DESCRIPTION_MAX_LENGTH } from "../../../consts/PatientConsts";
import EditableText from "../../general/EditableText/EditableText"
import SafeHTMLRenderer from "../../general/SafeHTMLRenderer";
import {EventCancellationTime} from "../../general/EventCancellationTime";
import SlateEditableText from "../../general/SlateEditableText/SlateEditableText";
import {Descendant} from "slate";
import {htmlToSlate, isSlateContentEmpty, slateToHtml} from "../../general/SlateEditableText/SlateHelpers";
import tippy, {Instance, Placement} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import {memoize} from "@fullcalendar/core/internal";
import MaskedDatePicker from "../../general/MaskedDatePicker";
import EventFilesUpload from "../EventFilesUpload";

interface Props {
    id: string;
}

type TypeDescriptionFormatting = 'bold' | 'italic' | 'underline';

interface State {
    eventId: string,
    openModal: boolean,
    events: CalendarEvent[],
    descriptionSlate: Descendant[],
    descriptionFormatting: boolean,
    descriptionTypeFormatting: TypeDescriptionFormatting,
    appointment?: boolean | null,
    selectedAppointment?: Appointment,
    appointmentList: Appointment[],
    eventType: string,
    repeatType: string,
    finishType: string,
    repeatByDaysCount: number,
    repeatByWeeksCount: number,
    repeatByMonthsCount: number,
    repeatSeveralTimesCount: number,
    repeatDays: string[],
    checkboxRepeatDays: Map<string, boolean>,
    startDate?: Date,
    endDate?: Date,
    cancellationTimeframeFrom: Date | undefined,
    cancellationTimeframeTo: Date | undefined,
    massive?: boolean | null,
    time: string,
    loading: boolean,
    editMode: boolean,
    journal: EventJournalRecord[],
    checkboxSelectedItemsSwitch: boolean,
    currentCalendarDate: Date,
    eventHasBeenChanged: boolean,
    cancellationTimeframeHasBeenChanged: boolean,
    prevState: State | null,
    calendarSelectedDate: Date | null,
    filterEventType: string | undefined;
    fileIds: string[];
    filesToUpload: File[];
}

export interface CalendarEvent {
    groupId: string,
    title: string, // Очищенный текст без HTML
    start: string,
    end?: string,
    backgroundColor?: string,
    url?: string,
    htmlDescription?: string, // Оригинальный HTML
}

export interface PatientEvent {
    _id: string,
    patientId: string,
    startDate: Date,
    endDate: Date,
    eventType: string,
    finishType: string,
    repeatType: string,
    repeatSeveralTimesCount: number,
    repeatByDaysCount: number,
    repeatByWeeksCount: number,
    repeatByMonthsCount: number,
    repeatDays: string[],
    description: string,
    journal: EventJournalRecord[],
    cancellationTimeframeFrom: Date | null,
    cancellationTimeframeTo: Date | null,
    massive?: boolean | null,
    fileIds?: string[],
}

export interface PatientEventFull extends PatientEvent {
    patient: Patient,
}

interface DropdownOptions {
    key: string,
    text: string,
    value: string,
}

export interface EventJournalRecord {
    id: string,
    status: string,
    date: Date,
    description: string,
    statusDate?: Date
}

class CureProgramTab extends React.PureComponent<Props, State> {

    // Хранилище всех активных tippy инстансов
    private tippyInstances: Instance[] = [];
    
    // список типов заданий
    private eventTypesOptions = getEventTypesOptions();

    state: State = {
        eventId: '',
        openModal: false,
        events: [],
        repeatType: '',
        eventType: '',
        descriptionSlate: EMPTY_SLATE_VALUE,
        descriptionFormatting: false,
        descriptionTypeFormatting: 'bold',
        appointment: false,
        selectedAppointment: undefined,
        appointmentList: [],
        finishType: FinishTypes.COUNTS,
        repeatSeveralTimesCount: 0,
        repeatByWeeksCount: 0,
        repeatByDaysCount: 0,
        repeatDays: [],
        checkboxRepeatDays: new Map(),
        cancellationTimeframeFrom: undefined,
        cancellationTimeframeTo: undefined,
        massive: false,
        time: '',
        loading: false,
        editMode: true,
        journal: [],
        checkboxSelectedItemsSwitch: false,
        currentCalendarDate: new Date(),
        eventHasBeenChanged: false,
        cancellationTimeframeHasBeenChanged: false,
        prevState: null,
        calendarSelectedDate: null,
        repeatByMonthsCount: 0,
        filterEventType: undefined,
        fileIds: [],
        filesToUpload: []
    };

    // Метод для уничтожения всех активных тултипов
    destroyAllTooltips = (): void => {
        this.tippyInstances.forEach(instance => {
            if (instance && !instance.state.isDestroyed) {
                instance.destroy();
            }
        });
        this.tippyInstances = [];
    };

    clearState = (shouldDestroyTooltips: boolean = false): void => {
        if (shouldDestroyTooltips) {
            this.destroyAllTooltips();
        }

        this.setState({
            eventId: '',
            openModal: false,
            repeatType: '',
            eventType: '',
            descriptionSlate: EMPTY_SLATE_VALUE,
            descriptionFormatting: false,
            descriptionTypeFormatting: 'bold',
            appointment: false,
            selectedAppointment: undefined,
            finishType: FinishTypes.COUNTS,
            endDate: undefined,
            repeatSeveralTimesCount: 0,
            repeatByWeeksCount: 0,
            repeatByDaysCount: 0,
            repeatByMonthsCount: 0,
            repeatDays: [],
            checkboxRepeatDays: new Map(),
            time: '',
            editMode: true,
            journal: [],
            checkboxSelectedItemsSwitch: false,
            cancellationTimeframeFrom: undefined,
            cancellationTimeframeTo: undefined,
            massive: false,
            eventHasBeenChanged: false,
            cancellationTimeframeHasBeenChanged: false,
            prevState: null,
            calendarSelectedDate: null,
            fileIds: [],
            filesToUpload: []
        });
    };

    handleModalClose = (): void => {
        this.clearState(false);
    };

    async componentDidMount() {
        // await this.load();
        this.setState({loading: true});
        await this.getEvents();
        await this.getAppointmentList();
    };

    async load() {
        this.setState({loading: true});
        await this.getEvents();
    };

    getAppointmentList = async (): Promise<void> => {
        this.setState({loading: true});

        const paginateOptions: PaginateOptions = {
            limit: 10000,
            page: 1,
            search: "",
            sort: "name"
        };

        const response: AppointmentPaginationResponse = await agent.AppointmentProvider.getList(paginateOptions);

        if (response) {
            this.setState({
                appointmentList: response.docs
            });
        }
        this.setState({loading: false});
    };

    onChangeRepeatingDays = (e: any, data: CheckboxProps) => {
        const item = data.value as string;
        const isChecked = data.checked as boolean;

        this.setState((prevState) => {
            return {
                checkboxRepeatDays: prevState.checkboxRepeatDays.set(item, isChecked),
                checkboxSelectedItemsSwitch: true
            }
        });
    };

    eventDateLabel: string = 'Дата';
    eventStartDateLabel: string = 'Дата начала';

    getEndDate = (): Date | undefined => {
        if (this.state.repeatType === RepeatTypes.NO_REPEATABLE) {
            return this.state.startDate;
        }
        if (this.state.finishType === FinishTypes.DATE && this.state.endDate) {
            return this.state.endDate;
        } else if (this.state.finishType === FinishTypes.COUNTS && this.state.repeatSeveralTimesCount && this.state.startDate) {
            if (this.state.repeatType === RepeatTypes.DAILY) {
                return getPatientDailyEventEndDate(this.state.startDate, this.state.repeatByDaysCount, this.state.repeatSeveralTimesCount);
            }

            if (this.state.repeatType === RepeatTypes.WEEKLY) {
                return getPatientWeeklyEventEndDate(this.state.startDate, this.state.repeatByWeeksCount, this.state.repeatSeveralTimesCount, this.getSelectedDaysOfWeek());
            }
            if (this.state.repeatType === RepeatTypes.MONTHLY) {
                return getPatientMonthlyEventEndDate(this.state.startDate, this.state.repeatByMonthsCount, this.state.repeatSeveralTimesCount);
            }
        }
        return undefined;
    };

    startCreateEvent = async () => {
        this.setState({
            startDate: new Date(),
            openModal: true,
            editMode: false,
            calendarSelectedDate: new Date(),
        });
    }


    onCreateEvent = async (): Promise<boolean> => {
        let finalFileIds = [...this.state.fileIds];
        if (this.state.filesToUpload && this.state.filesToUpload.length > 0) {
            this.setState({loading: true});
            try {
                const uploadedIds = await uploadPendingFiles(this.state.filesToUpload);
                finalFileIds = [...finalFileIds, ...uploadedIds];
            } catch (error) {
                const err = error as any;
                this.setState({loading: false});
                alert(err.message);
                return false;
            }
        }

        await agent.PatientEventProvider.create({
            _id: '',
            patientId: this.props.id,
            description: slateToHtml(this.state.descriptionSlate),
            startDate: this.state.startDate ? this.setTimeForDate(this.state.startDate!, this.state.time) : undefined,
            endDate: this.setTimeForDate(this.getEndDate()!, this.state.time),
            cancellationTimeframeFrom: buildCancellationTimeframeFrom(this.state.cancellationTimeframeFrom),
            cancellationTimeframeTo: buildCancellationTimeframeTo(this.state.cancellationTimeframeTo),
            eventType: this.state.eventType,
            finishType: this.state.finishType,
            repeatType: this.state.repeatType,
            repeatSeveralTimesCount: this.state.repeatSeveralTimesCount,
            repeatByDaysCount: this.state.repeatByDaysCount,
            repeatByWeeksCount: this.state.repeatByWeeksCount,
            repeatByMonthsCount: this.state.repeatByMonthsCount,
            repeatDays: this.getSelectedDaysOfWeek(),
            journal: this.state.journal,
            fileIds: finalFileIds,
        });

        return true;
    };

    saveAndKeep = async (): Promise<void> => {
        const success = await this.onCreateEvent();
        if (!success) return;
        this.setState({
            eventId: '',
            descriptionSlate: EMPTY_SLATE_VALUE,
            fileIds: [],
            filesToUpload: [],
            loading: false
        }, async () => {
            await this.getEvents();
            alert(getGeneralTitle(GeneralTitleCase.saveAndKeepEventMessage));
        });
    }

    saveAndClose = async (): Promise<void> => {
        const success = await this.onCreateEvent();
        if (!success) return;
        this.clearState(true);
        await this.getEvents();
    }

    onEditEvent = async (): Promise<void> => {
        if (this.state.startDate && this.getEndDate()) {
            let finalFileIds = [...this.state.fileIds];
            if (this.state.filesToUpload && this.state.filesToUpload.length > 0) {
                this.setState({loading: true});
                try {
                    const uploadedIds = await uploadPendingFiles(this.state.filesToUpload);
                    finalFileIds = [...finalFileIds, ...uploadedIds];

                    this.setState({
                        fileIds: finalFileIds,
                        filesToUpload: []
                    });
                } catch (error) {
                    const err = error as any;
                    this.setState({loading: false});
                    alert(err.message);
                    return;
                }
            }

            await agent.PatientEventProvider.edit({
                _id: this.state.eventId,
                patientId: this.props.id,
                description: slateToHtml(this.state.descriptionSlate),
                startDate: this.setTimeForDate(this.state.startDate!, this.state.time),
                endDate: this.setTimeForDate(this.getEndDate()!, this.state.time),
                eventType: this.state.eventType,
                finishType: this.state.finishType,
                repeatType: this.state.repeatType,
                repeatSeveralTimesCount: this.state.repeatSeveralTimesCount,
                repeatByDaysCount: this.state.repeatByDaysCount,
                repeatByWeeksCount: this.state.repeatByWeeksCount,
                repeatByMonthsCount: this.state.repeatByMonthsCount,
                repeatDays: this.getSelectedDaysOfWeek(),
                journal: this.state.journal,
                cancellationTimeframeFrom: buildCancellationTimeframeFrom(this.state.cancellationTimeframeFrom),
                cancellationTimeframeTo: buildCancellationTimeframeTo(this.state.cancellationTimeframeTo),
                fileIds: finalFileIds,
            });

            this.clearState(true);

            await this.getEvents();
        }
    };

    onOpenEvent = async (eventId: string): Promise<void> => {
        this.setState({/*loading: true,*/ editMode: true, eventId: eventId});

        await agent.PatientEventProvider.open(eventId).then((patientEvent: PatientEvent): void => {
            if (patientEvent) {

                this.setState({
                    openModal: true,
                    repeatType: patientEvent.repeatType,
                    eventType: patientEvent.eventType,
                    descriptionSlate: htmlToSlate(patientEvent.description),
                    finishType: patientEvent.finishType,
                    repeatSeveralTimesCount: patientEvent.repeatSeveralTimesCount,
                    repeatByWeeksCount: patientEvent.repeatByWeeksCount,
                    repeatByDaysCount: patientEvent.repeatByDaysCount,
                    repeatByMonthsCount: patientEvent.repeatByMonthsCount,
                    repeatDays: patientEvent.repeatDays,
                    checkboxRepeatDays: this.getCheckedCheckboxes(patientEvent.repeatDays),
                    startDate: new Date(convertDateToCalendarDate(patientEvent.startDate)),
                    endDate: new Date(convertDateToCalendarDate(patientEvent.endDate)),
                    cancellationTimeframeFrom: patientEvent.cancellationTimeframeFrom ? patientEvent.cancellationTimeframeFrom : undefined,
                    cancellationTimeframeTo: patientEvent.cancellationTimeframeTo ? patientEvent.cancellationTimeframeTo : undefined,
                    time: this.getEventTime(new Date(patientEvent.startDate)),
                    massive: patientEvent.massive,
                    journal: patientEvent.journal,
                    loading: false,
                    editMode: true,
                    fileIds: patientEvent.fileIds || [],
                    filesToUpload: [],
                }, () => {
                    this.setState({prevState: this.state})
                });
            }
        });
    };

    getEventTime = (date: Date): string => {
        return moment(date).tz(getTZ()).format("HH:mm");
    };

    setTimeForDate = (date: Date, time: string): Date => {
        const timeArray: string[] = time.split(':');
        return moment.tz([date.getFullYear(), date.getMonth(), date.getDate(),
            safeParseInt(timeArray[0]), safeParseInt(timeArray[1])], getTZ()).toDate();
    };

    onRemoveEvent = async (): Promise<void> => {
        await agent.PatientEventProvider.remove(this.state.eventId);

        this.clearState(true);

        await this.getEvents();
    };

    getCheckedCheckboxes = (checkboxes: string[]): Map<string, boolean> => {
        const checkboxesMap: Map<string, boolean> = new Map<string, boolean>();

        checkboxes.forEach((el: string) => {
            checkboxesMap.set(el, true);
        })

        return checkboxesMap;
    };

    onChangeFinishType = (e: FormEvent<HTMLInputElement>, data: CheckboxProps): void => {
        this.setState({finishType: data.value as string});

        if (data.value === FinishTypes.DATE) {
            this.setState({
                repeatSeveralTimesCount: 0,
                eventHasBeenChanged: true
            });
        } else if (data.value === FinishTypes.COUNTS) {
            this.setState({
                endDate: undefined,
                eventHasBeenChanged: true
            });
        }
    };

    finishTypeDateCheckbox = (label: string | undefined = undefined) => {
        return (
            <Form.Group className={styles.formField}>
                <Checkbox
                    disabled={this.isReadOnly()}
                    className={styles.radioCheckbox}
                    radio
                    name={'checkboxRadioGroup'}
                    value={FinishTypes.DATE}
                    checked={this.state.finishType === FinishTypes.DATE}
                    onChange={this.onChangeFinishType}
                />
                <div className={styles.endDate}>
                    <label> {label ?? "Дата"} </label>
                    <div style={{marginLeft: "6px"}}>
                        <MaskedDatePicker
                            selected={this.state.finishType === FinishTypes.DATE && this.state.endDate ? new Date(this.state.endDate) : null}
                            onChange={(date?: Date) => {
                                this.setState({
                                    endDate: date,
                                    eventHasBeenChanged: true
                                })
                            }}
                            onKeyDown={handleDatePickerKeyDown}
                            disabled={(this.state.finishType !== FinishTypes.DATE) || this.isReadOnly()}
                        />
                    </div>
                </div>
            </Form.Group>
        )
    };

    afterRepeatCountsCheckbox = () => {
        return (
            <>
                <label> После </label>
                <Form.Input width={2}
                            value={(this.state.finishType === FinishTypes.COUNTS && this.state.repeatSeveralTimesCount !== 0) ? this.state.repeatSeveralTimesCount : ''}
                            disabled={(this.state.finishType !== FinishTypes.COUNTS) || this.isReadOnly()}
                            error={this.isRepeatSeveralTimesError()}
                            onChange={(e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
                                this.setState({
                                    repeatSeveralTimesCount: safeParseInt(data.value as string),
                                    eventHasBeenChanged: true
                                })
                            }}
                />
                <label> повторений</label>
            </>
        )
    };

    getDateFields = (): JSX.Element => {
        switch (this.state.repeatType) {
            case RepeatTypes.NO_REPEATABLE: {
                return (
                    <Form.Field width={3}>
                        <label>{this.eventDateLabel}</label>
                        <MaskedDatePicker
                            disabled={this.isReadOnly()}
                            selected={this.state.startDate ? new Date(this.state.startDate) : null}
                            onChange={(date?: Date) => {
                                this.setState({
                                    startDate: date,
                                    eventHasBeenChanged: true
                                })
                            }}
                            onKeyDown={handleDatePickerKeyDown}
                        />
                    </Form.Field>
                )
            }

            case RepeatTypes.DAILY: {
                return (
                    <>
                        <Form.Field width={3}>
                            <label>{this.eventStartDateLabel}</label>
                            <MaskedDatePicker
                                disabled={this.isReadOnly()}
                                selected={this.state.startDate ? new Date(this.state.startDate) : null}
                                onChange={(date?: Date) => {
                                    this.setState({
                                        startDate: date,
                                        eventHasBeenChanged: true
                                    })
                                }}
                                onKeyDown={handleDatePickerKeyDown}
                            />
                        </Form.Field>

                        <Form.Group className={styles.formField}>
                            <label>Повторять каждый </label>
                            <Form.Input width={2}
                                        disabled={this.isReadOnly()}
                                        value={this.state.repeatByDaysCount === 0 ? '' : this.state.repeatByDaysCount}
                                        onChange={(e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
                                            this.setState({
                                                repeatByDaysCount: safeParseInt(data.value as string),
                                                eventHasBeenChanged: true
                                            })
                                        }}
                            />
                            <label> день</label>
                        </Form.Group>

                        <Form.Field>
                            <label>Завершить</label>
                        </Form.Field>
                        <Form.Group className={styles.formField}>
                            <Checkbox
                                disabled={this.isReadOnly()}
                                className={styles.radioCheckbox}
                                radio
                                name={'checkboxRadioGroup'}
                                value={FinishTypes.COUNTS}
                                checked={this.state.finishType === FinishTypes.COUNTS}
                                onChange={this.onChangeFinishType}
                            />

                            {
                                this.afterRepeatCountsCheckbox()
                            }
                        </Form.Group>
                        {
                            this.finishTypeDateCheckbox()
                        }
                    </>
                )
            }

            case RepeatTypes.WEEKLY: {
                return (
                    <>
                        <Form.Field width={3}>
                            <label>{this.eventStartDateLabel}</label>
                            <MaskedDatePicker
                                disabled={this.isReadOnly()}
                                selected={this.state.startDate ? new Date(this.state.startDate) : null}
                                onChange={(date?: Date) => {
                                    this.setState({
                                        startDate: date,
                                        eventHasBeenChanged: true
                                    })
                                }}
                                onKeyDown={handleDatePickerKeyDown}
                            />
                        </Form.Field>

                        <Form.Group className={styles.formField}>
                            <label>Повторять каждую </label>
                            <Form.Input width={2}
                                        disabled={this.isReadOnly()}
                                        value={this.state.repeatByWeeksCount === 0 ? '' : this.state.repeatByWeeksCount}
                                        onChange={(e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => this.setState({repeatByWeeksCount: safeParseInt(data.value as string)})}

                            />
                            <label> неделю</label>
                        </Form.Group>

                        <Form.Group>
                            {
                                daysCheckboxes.map(item => (
                                    <Checkbox
                                        disabled={this.isReadOnly()}
                                        className={styles.checkboxItem}
                                        key={item.key}
                                        label={item.label}
                                        value={item.name}
                                        defaultChecked={this.state.checkboxRepeatDays.get(item.name)}
                                        onChange={this.onChangeRepeatingDays}
                                    />
                                ))
                            }

                        </Form.Group>

                        <Form.Field>
                            <label>Завершить</label>
                        </Form.Field>
                        <Form.Group className={styles.formField}>
                            <Checkbox
                                disabled={this.isReadOnly()}
                                className={styles.radioCheckbox}
                                radio
                                name={'checkboxRadioGroup'}
                                value={FinishTypes.COUNTS}
                                checked={this.state.finishType === FinishTypes.COUNTS}
                                onChange={this.onChangeFinishType}
                            />

                            {
                                this.afterRepeatCountsCheckbox()
                            }
                        </Form.Group>
                        {
                            this.finishTypeDateCheckbox()
                        }
                    </>

                )
            }

            case RepeatTypes.MONTHLY: {
                return (
                    <>
                        <Form.Field width={3}>
                            <label>{this.eventStartDateLabel}</label>
                            <MaskedDatePicker
                                disabled={this.isReadOnly()}
                                selected={this.state.startDate ? new Date(this.state.startDate) : null}
                                onChange={(date?: Date) => {
                                    this.setState({
                                        startDate: date,
                                        eventHasBeenChanged: true
                                    })
                                }}
                                onKeyDown={handleDatePickerKeyDown}
                            />
                        </Form.Field>

                        <Form.Group className={styles.formField}>
                            <label>Повторять каждый </label>
                            <Form.Input width={2}
                                        disabled={this.isReadOnly()}
                                        value={this.state.repeatByMonthsCount === 0 ? '' : this.state.repeatByMonthsCount}
                                        onChange={(e: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
                                            this.setState({
                                                repeatByMonthsCount: safeParseInt(data.value as string),
                                                eventHasBeenChanged: true
                                            })
                                        }}
                            />
                            <label> месяц</label>
                        </Form.Group>

                        <Form.Field>
                            <label>Завершить</label>
                        </Form.Field>
                        <Form.Group className={styles.formField}>
                            <Checkbox
                                disabled={this.isReadOnly()}
                                className={styles.radioCheckbox}
                                radio
                                name={'checkboxRadioGroup'}
                                value={FinishTypes.COUNTS}
                                checked={this.state.finishType === FinishTypes.COUNTS}
                                onChange={this.onChangeFinishType}
                            />

                            {
                                this.afterRepeatCountsCheckbox()
                            }
                        </Form.Group>
                        {
                            this.finishTypeDateCheckbox("Дата")
                        }
                    </>
                )
            }

            default: {
                return (
                    <></>
                )
            }
        }
    };

    getEvents = async (): Promise<void> => {
        this.destroyAllTooltips();

        let calendarEvents: CalendarEvent[] = [];

        const eventDescriptionList: PatientEvent[] = await agent.PatientEventProvider.getList(this.props.id, this.state.filterEventType);
        if (eventDescriptionList) {
            eventDescriptionList.forEach((item: PatientEvent) => {
                const eventArray = EventRepeater(item);
                eventArray.forEach((event: CalendarEvent) => {
                    event.htmlDescription = event.title;
                    event.title = event.title.replace(/<[^>]*>/g, '');
                });
                calendarEvents.push(...eventArray);
            });
            this.setState({events: calendarEvents, loading: false});
        } else {
            this.setState({loading: false});
        }
    };

    getSelectedDaysOfWeek = (): string[] => {
        let daysArray: string[] = [];

        this.state.checkboxRepeatDays.forEach((value: boolean, key: string) => {
            if (value) {
                daysArray.push(key);
            }
        })

        return daysArray;
    };

    isRepeatSeveralTimesError = (): boolean => {
        return (this.state.repeatSeveralTimesCount > 500);
    }

    isEndDateError = (): boolean => {
        return !this.getEndDate() || (this.getEndDate()! > (new Date(2100, 1, 1)));
    }

    isStartDateError = (): boolean => {
        return !this.state.startDate || (this.state.startDate > (new Date(2100, 1, 1)));
    }

    isReadOnly = (): boolean => {
        return hasRole(UserRole.OBSERVER) || (this.state.massive ? this.state.massive : false);
    };

    isSaveDisabled = (): boolean => {
        const date = new Date();
        const now = moment.tz([date.getFullYear(), date.getMonth(), date.getDate(),
            date.getHours(), date.getMinutes()], getTZ()).toDate();

        const isValidCancellationTimeframeFields = (): boolean => {
            const isEmptyField = (value: any): boolean => {
                return value === null || value === 'Invalid Date';
            }

            return isEmptyField(this.state.cancellationTimeframeFrom) === isEmptyField(this.state.cancellationTimeframeTo);
        }

        if (this.state.eventId &&
            !this.state.eventHasBeenChanged &&
            this.state.cancellationTimeframeHasBeenChanged &&
            isValidCancellationTimeframeFields()
        ) {
            return false;
        }

        if (!this.eventTypesOptions.some(type => type.value == this.state.eventType)){
            return true;
        }
        
        if (this.isRepeatSeveralTimesError() || this.isEndDateError()) {
            return true;
        }

        if (this.isStartDateError()) {
            return true;
        }

        if (this.state.prevState) {
            if (
                this.state.eventType === this.state.prevState.eventType &&
                this.state.descriptionSlate === this.state.prevState.descriptionSlate &&
                this.state.repeatType === this.state.prevState.repeatType &&
                this.state.repeatByDaysCount === this.state.prevState.repeatByDaysCount &&
                this.state.time === this.state.prevState.time &&
                this.state.repeatByWeeksCount === this.state.prevState.repeatByWeeksCount &&
                this.state.repeatByMonthsCount === this.state.prevState.repeatByMonthsCount &&
                this.state.repeatSeveralTimesCount === this.state.prevState.repeatSeveralTimesCount &&
                this.state.startDate?.toDateString() === this.state.prevState.startDate?.toDateString() &&
                this.state.endDate?.toDateString() === this.state.prevState.endDate?.toDateString() &&
                this.state.checkboxSelectedItemsSwitch === this.state.prevState.checkboxSelectedItemsSwitch &&
                JSON.stringify(this.state.fileIds) === JSON.stringify(this.state.prevState.fileIds || []) &&
                (this.state.filesToUpload || []).length === 0
            ) {
                return true;
            }
        }

        if (this.state.prevState) {
            if (
                this.state.eventHasBeenChanged &&
                this.state.eventType === this.state.prevState.eventType &&
                this.state.descriptionSlate === this.state.prevState.descriptionSlate &&
                this.state.repeatType === this.state.prevState.repeatType &&
                this.state.repeatByDaysCount === this.state.prevState.repeatByDaysCount &&
                this.state.time === this.state.prevState.time &&
                this.state.repeatByWeeksCount === this.state.prevState.repeatByWeeksCount &&
                this.state.repeatByMonthsCount === this.state.prevState.repeatByMonthsCount &&
                this.state.repeatSeveralTimesCount === this.state.prevState.repeatSeveralTimesCount &&
                this.state.startDate?.toDateString() === this.state.prevState.startDate?.toDateString() &&
                this.state.endDate && this.setTimeForDate(this.state.endDate, this.state.time) > now &&
                JSON.stringify(this.state.fileIds) === JSON.stringify(this.state.prevState.fileIds || []) &&
                (this.state.filesToUpload || []).length === 0
            ) {
                return false;
            }
        }

        let isRepeatTypeFilled: boolean = false;

        switch (this.state.repeatType) {
            case RepeatTypes.NO_REPEATABLE: {
                isRepeatTypeFilled = true;

                break
            }
            case RepeatTypes.DAILY: {
                if (this.state.finishType === FinishTypes.COUNTS) {
                    isRepeatTypeFilled = !!this.state.repeatByDaysCount && !!this.state.repeatSeveralTimesCount;
                } else {
                    isRepeatTypeFilled = !!this.state.repeatByDaysCount && !!this.state.endDate && this.state.endDate > now;
                }

                break
            }

            case RepeatTypes.WEEKLY: {
                if (this.state.finishType === FinishTypes.COUNTS) {
                    isRepeatTypeFilled = !!this.state.repeatByWeeksCount && !!this.state.repeatSeveralTimesCount && this.getSelectedDaysOfWeek().length > 0;
                } else {
                    isRepeatTypeFilled = !!this.state.repeatByWeeksCount && !!this.state.endDate && this.state.endDate > now && this.getSelectedDaysOfWeek().length > 0;
                }

                break
            }

            case RepeatTypes.MONTHLY: {
                if (this.state.finishType === FinishTypes.COUNTS) {
                    isRepeatTypeFilled = !!this.state.repeatByMonthsCount && !!this.state.repeatSeveralTimesCount;
                } else {
                    isRepeatTypeFilled = !!this.state.repeatByMonthsCount && !!this.state.endDate && this.state.endDate > now;
                }

                break
            }
        }

        let result = !isValidCancellationTimeframeFields() ||
            !this.state.repeatType ||
            !this.state.eventType ||
            isSlateContentEmpty(this.state.descriptionSlate) ||
            (!!this.state.startDate && this.setTimeForDate(this.state.startDate, this.state.time) < now) ||
            !(this.state.time && !this.state.time.includes('_')) ||
            !isRepeatTypeFilled;

        return result;
    };

    getDefaultTime = (): string => {
        if (this.state.time) {
            return this.state.time;
        } else {
            this.setState({time: '08:00'});

            return '08:00';
        }
    };

    // Функции для FullCalendar
    memoizedEvents = memoize((events: CalendarEvent[]) => {
        return events.map(event => {
            const start = new Date(event.start);
            if (start.getHours() === 23 && start.getMinutes() >= 1) {
                return {
                    ...event,
                    end: new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59).toISOString()
                };
            }
            return event;
        });
    });

    handleEventClick = (e: EventClickArg): void => {
        this.setState({
            calendarSelectedDate: e.event.start,
        });
        this.onOpenEvent(e.event.groupId.toString());
    };

    handleDateClick = (arg: DateClickArg): void => {
        if (!hasRole(UserRole.OBSERVER)) {
            this.setState({
                startDate: new Date(arg.dateStr),
                time: arg.date.getHours() ? moment(arg.date).format("HH:mm") : "",
                openModal: true,
                editMode: false,
                calendarSelectedDate: new Date(arg.dateStr),
            });
        }
    };

    handleDatesSet = (arg: any): void => {
        this.setState({ currentCalendarDate: arg.view.currentStart });
    };

    handleEventDidMount = (arg: any): void => {
        try {
            const d = arg.event.start!;
            const dd = [d.getHours(), d.getMinutes()].map((a) => (a < 10 ? '0' + a : a));
            let s = dd.join(':') + ": " + arg.event.title;
            let html = arg.event.extendedProps.htmlDescription || '';

            // Переносы для длинных слов более 35 символов
            html = html.replace(/(>)([^<]{35,}?)(<|$)/g, (match: string, open: string, text: string, close: string) =>
                open + text.replace(/([^\s]{35})/g, '$1<wbr>') + close
            );
            // Обработка абзацев и переносов строк
            html = html.replace(/\n/g, '<br>').replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
            html = `<div style="font-weight: bold;">${dd.join(':')}</div>${html}`;

            if (!arg.el || !html) return;
            // Очищаем предыдущий экземпляр tippy
            const existingTippy = (arg.el as any)._tippy as Instance | undefined;
            if (existingTippy && !existingTippy.state.isDestroyed) {
                existingTippy.destroy();
            }

            const container = document.createElement('div');
            document.body.appendChild(container);

            const calendarView = arg.view.type;
            let placement: Placement = 'right-end';
            if (calendarView.includes('month') || calendarView.includes('year')) {
                placement = 'top';
            } else if (calendarView.includes('timeGridDay') || calendarView.includes('timeGridWeek')) {
                placement = 'top-start';
            }

            const instances = tippy(arg.el, {
                content: html,
                allowHTML: true,
                trigger: 'mouseenter focus',
                interactive: true,
                placement: placement,
                theme: 'light-border',
                delay: 50,
                appendTo: container,
                zIndex: 9999,
                onTrigger: (instance, event) => {
                    if (event.type === 'mouseleave') {
                        setTimeout(() => {
                            if (!instance.state.isDestroyed) {
                                instance.hide();
                            }
                        }, 50);
                    }
                },
                onShow: (instance) => {
                    const popper = instance.popper;
                    popper.addEventListener('mouseleave', () => {
                        setTimeout(() => instance.hide(), 50);
                    });
                },
                onDestroy: (instance) => {
                    this.tippyInstances = this.tippyInstances.filter(i => i !== instance);
                }
            });

            const instance = Array.isArray(instances) ? instances[0] : instances;
            // Сохраняем ссылку на экземпляр
            (arg.el as any)._tippy = instance;
            if (instance) {
                this.tippyInstances.push(instance);
            }
        } catch (error) {
            console.error('Ошибка при наведении:', error);
        }
    };



    render() {
        const modalCreateHeader: string = 'Создать задание';
        const modalEditHeader: string = 'Изменение задания';
        const modalShowMassiveHeader: string = 'Просмотр параметров массовой рассылки'


        return (
            <div className={styles.container}>
                {
                    this.state.openModal &&
                    <Modal
                        onClose={this.handleModalClose}
                        open={this.state.openModal}
                        closeOnDocumentClick={false}
                        closeOnPortalMouseLeave={false}
                        closeOnTriggerMouseLeave={false}
                        closeOnEscape={false}
                    >
                        <Modal.Header>
                            {/*{this.state.editMode ? modalEditHeader : modalCreateHeader}*/}
                            {this.state.massive ? modalShowMassiveHeader : (this.state.editMode ? modalEditHeader : modalCreateHeader)}
                            {
                                this.state.calendarSelectedDate &&
                                <span style={{
                                    float: "right",
                                    display: "block"
                                }}>{this.state.calendarSelectedDate.toLocaleDateString()}</span>
                            }
                        </Modal.Header>

                        <Modal.Content>
                            <Form>

                                <Form.Field width={4}>
                                    <label>Тип задания</label>
                                    <Dropdown
                                        disabled={this.isReadOnly()}
                                        placeholder={'Выберите тип задания'}
                                        selection
                                        options={getEventTypesOptions()}
                                        defaultValue={this.state.eventType}
                                        onChange={(e: SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                            this.setState({
                                                eventType: data.value as string,
                                                eventHasBeenChanged: true
                                            })
                                        }}
                                    />
                                </Form.Field>

                                <Form.Checkbox
                                    label={getGeneralTitle(GeneralTitleCase.appointmentstab)}
                                    disabled={this.isReadOnly()}
                                    checked={this.state.appointment ? this.state.appointment : false}
                                    onChange={(e, data) => {
                                        this.setState({ appointment: data.checked ? true : false });
                                        if (!data.checked) this.setState({ selectedAppointment: undefined });
                                    }}
                                />
                                <Form.Field width={8}>
                                    <label>Описание задания</label>
                                    {this.state.appointment && (
                                        <div style={{ marginBottom: '1em' }}>
                                            <Dropdown
                                                fluid
                                                disabled={this.isReadOnly()}
                                                placeholder={`Выберите ${getGeneralTitle(GeneralTitleCase.appointmentsim)}`}
                                                value={this.state.selectedAppointment?._id}
                                                selection
                                                search
                                                clearable
                                                noResultsMessage={textLabels.noResultsMessage}
                                                options={this.state.appointmentList.map((el) => ({
                                                    key: el._id,
                                                    text: el.name.replace(/<[^>]*>/g, ''),
                                                    value: el._id,
                                                    content: <SafeHTMLRenderer html={el.name} />,
                                                } as DropdownItemProps))}
                                                trigger={
                                                    this.state.selectedAppointment ? (
                                                        <SafeHTMLRenderer html={this.state.selectedAppointment.name} />
                                                    ) : ""
                                                }
                                                onChange={(_: SyntheticEvent, { value }: DropdownProps) => {
                                                    const selected = value ? this.state.appointmentList.find(el => el._id === value) : undefined;

                                                    if (selected) {
                                                        this.setState({
                                                            selectedAppointment: selected,
                                                            descriptionSlate: htmlToSlate(selected.name || ''),
                                                            eventHasBeenChanged: true,
                                                        });
                                                    } else {
                                                        this.setState({
                                                            selectedAppointment: undefined,
                                                            eventHasBeenChanged: true,
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                    <SlateEditableText
                                        value={this.state.descriptionSlate}
                                        onChange={(newDescription) => {
                                            this.setState({
                                                descriptionSlate: newDescription,
                                                eventHasBeenChanged: true,
                                                selectedAppointment: undefined,
                                                appointment: false,
                                            });
                                        }}
                                        maxLength={EVENT_DESCRIPTION_MAX_LENGTH}
                                        disabled={this.isReadOnly()}
                                    />
                                    <EventFilesUpload
                                        fileIds={this.state.fileIds}
                                        onFilesChange={(fileIds: string[]) => {
                                            this.setState({ fileIds, eventHasBeenChanged: true })
                                        }}
                                        filesToUpload={this.state.filesToUpload}
                                        onFilesToUploadChange={(files: File[]) => {
                                            this.setState({ filesToUpload: files, eventHasBeenChanged: true })
                                        }}
                                        uploading={this.state.loading}
                                        readOnly={this.isReadOnly()}
                                    />
                                </Form.Field>

                                <Form.Field width={4}>
                                    <label>Повторение</label>
                                    <Dropdown
                                        disabled={this.isReadOnly()}
                                        placeholder={'Выберите тип повторения'}
                                        selection
                                        options={getRepeatTypesOptions()}
                                        defaultValue={this.state.repeatType}
                                        onChange={(e: SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                            this.setState({
                                                repeatType: data.value as string,
                                                eventHasBeenChanged: true
                                            })
                                        }}
                                    />
                                </Form.Field>

                                <EventCancellationTime
                                    label="Исключение"
                                    fromDate={this.state.cancellationTimeframeFrom ? new Date(this.state.cancellationTimeframeFrom) : null}
                                    toDate={this.state.cancellationTimeframeTo ? new Date(this.state.cancellationTimeframeTo) : null}
                                    repeatType={this.state.repeatType as RepeatTypes}
                                    onFromDateChange={(date?: Date) => {
                                        this.setState({
                                            cancellationTimeframeFrom: date,
                                            cancellationTimeframeHasBeenChanged: true
                                        })
                                    }}
                                    onToDateChange={(date?: Date) => {
                                        this.setState({
                                            cancellationTimeframeTo: date,
                                            cancellationTimeframeHasBeenChanged: true
                                        })
                                    }}
                                    massive={this.isReadOnly()}
                                    onKeyDown={handleDatePickerKeyDown}
                                />

                                {
                                    this.state.repeatType && this.getDateFields()
                                }

                                <Form.Field width={3}>
                                    <label>Время</label>
                                </Form.Field>
                                <Form.Field
                                    width={2}
                                    disabled={this.isReadOnly()}>
                                    <ReactInputMask
                                        disabled={this.isReadOnly()}
                                        mask={'99:99'}
                                        alwaysShowMask={false}
                                        value={this.state.time}
                                        style={{ margin: "0 0 10em 0" }}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            let time: string = e.target.value;
                                            const hours = time.substring(0, 2);
                                            const minutes = time.substring(3, 5);
                                            if (parseInt(hours, 10) >= 24) {
                                                time = `23:${minutes}`;
                                            } else if (parseInt(minutes, 10) >= 60) {
                                                time = `${hours}:59`;
                                            }
                                            this.setState({
                                                time: time,
                                                eventHasBeenChanged: true
                                            });
                                        }}
                                    />
                                </Form.Field>

                            </Form>

                        </Modal.Content>

                        <Modal.Actions>
                            {
                                this.state.editMode ?
                                    (
                                        !(this.state.massive || hasRole(UserRole.OBSERVER)) && (
                                            <>
                                                <Button
                                                    color={'yellow'}
                                                    content={textLabels.deleteButton}
                                                    onClick={this.onRemoveEvent}
                                                />
                                                <Button
                                                    content={textLabels.editButton}
                                                    disabled={this.isSaveDisabled()}
                                                    onClick={this.onEditEvent}
                                                    positive
                                                />
                                            </>)
                                    )
                                    :
                                    <>
                                        <Button
                                            content={textLabels.saveButton + ' и продолжить'}
                                            disabled={this.isSaveDisabled()}
                                            onClick={this.saveAndKeep}
                                            color={'blue'}
                                        />
                                        <Button
                                            content={textLabels.saveButton + ' и закрыть'}
                                            disabled={this.isSaveDisabled()}
                                            onClick={this.saveAndClose}
                                            positive
                                        />
                                    </>
                            }

                            <Button
                                content={textLabels.cancelButton}
                                color={'grey'}
                                onClick={this.handleModalClose}
                            />
                        </Modal.Actions>
                    </Modal>
                }

                {
                    this.state.loading ?
                        <Loader active/>
                        :
                        <div>
                            <Form>
                                <Form.Group className={styles.formField}>
                                    {!hasRole(UserRole.OBSERVER) && <Form.Button onClick={this.startCreateEvent}
                                                 color={'green'}
                                                 type={'submit'}>
                                        <label>
                                            {textLabels.createButton}
                                        </label>
                                    </Form.Button>}
                                    <Form.Field width={"3"}>
                                        <label>
                                            Тип заданий
                                        </label>
                                        <Dropdown
                                            selection
                                            clearable={true}
                                            value={this.state.filterEventType}
                                            onChange={(event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                                this.setState({filterEventType: (data.value && data.value !== "" ? data.value.toString() : undefined)},
                                                    this.getEvents)
                                            }}
                                            options={getEventTypesOptions()}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Form>

                            <MediaQuery minWidth={1224}>
                                <FullCalendar
                                    plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin]}
                                    headerToolbar={{
                                        left: 'prev,next today',
                                        center: 'title',
                                        right: 'dayGridMonth,timeGridWeek,timeGridDay,month,year'
                                    }}
                                    views={{
                                        year: {
                                            type: 'listYear',
                                            buttonText: 'Повестка год'
                                        },
                                        month: {
                                            type: 'listMonth',
                                            buttonText: 'Повестка месяц'
                                        },
                                    }}
                                    nextDayThreshold={'24:00:00'}
                                    locale={ruLocale}
                                    displayEventTime={true}
                                    initialView="dayGridMonth"
                                    events={this.memoizedEvents(this.state.events)}
                                    eventClick={this.handleEventClick}
                                    dateClick={this.handleDateClick}
                                    eventTimeFormat={{
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        meridiem: false
                                    }}
                                    eventDidMount={this.handleEventDidMount}
                                    initialDate={this.state.currentCalendarDate}
                                    datesSet={this.handleDatesSet}
                                    slotMinTime="00:00:00"
                                    slotMaxTime="24:00:00"
                                    allDaySlot={false}
                                    displayEventEnd={false}
                                />
                            </MediaQuery>
                            <MediaQuery maxWidth={1224}>
                                <FullCalendar
                                    plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin]}
                                    headerToolbar={{
                                        left: 'prev,next today',
                                        center: 'title',
                                        right: 'month,year'

                                    }}
                                    views={{
                                        year: {
                                            type: 'listYear',
                                            buttonText: 'Повестка год'
                                        },
                                        month: {
                                            type: 'listMonth',
                                            buttonText: 'Повестка месяц'
                                        }
                                    }}
                                    locale={ruLocale}
                                    displayEventTime={true}
                                    nextDayThreshold={'24:00:00'}
                                    initialView="listMonth"
                                    events={this.state.events}
                                    eventClick={this.handleEventClick}
                                    dateClick={this.handleDateClick}
                                    eventTimeFormat={{
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        meridiem: false
                                    }}

                                    eventDidMount={this.handleEventDidMount}

                                    initialDate={this.state.currentCalendarDate}
                                    datesSet={this.handleDatesSet}
                                />
                            </MediaQuery>

                        </div>
                }
            </div>

        );
    }
}

export default CureProgramTab;
